export const getPseudonym = (state, id) => state.pseudonym.pseudonyms.entries[id];
